import type { CartLine, Order } from "@shared/contracts";

export function displayOrderNumber(order: Pick<Order, "clientId" | "id" | "orderNo">): string {
  // The legacy Admin used the final six characters of its persisted order id
  // as the visible order number. Keep that familiar identity for imported
  // history while new POSNext orders continue to use their assigned orderNo.
  if (order.clientId === "legacy-mongo-import-persistent") return order.id.slice(-6);
  return order.orderNo ?? order.id.slice(0, 8);
}

export function orderLineAmount(order: Pick<Order, "lines" | "subtotalMinor">, line: CartLine): number {
  const baseSubtotal = order.lines.reduce((sum, candidate) => sum + candidate.unitPriceMinor * candidate.quantity, 0);
  const optionSubtotal = order.lines.reduce((sum, candidate) => sum + (candidate.options ?? []).reduce((optionSum, option) => optionSum + option.priceMinor, 0) * candidate.quantity, 0);
  const optionsAreIncludedInSubtotal = baseSubtotal + optionSubtotal === order.subtotalMinor;
  const optionMinor = optionsAreIncludedInSubtotal ? (line.options ?? []).reduce((sum, option) => sum + option.priceMinor, 0) : 0;
  return (line.unitPriceMinor + optionMinor) * line.quantity;
}
